import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';

@Component({
    selector: 'app-blurbackdrop',
    templateUrl: './blurbackdrop.component.html',
    styleUrls: ['./blurbackdrop.component.scss'],
    standalone: false
})
export class BlurbackdropComponent implements OnInit {

  constructor( private modelService: NgbModal, private aiSourcingService: AiSourcingService) { }
  projectNumber:string;
  successMessage: string;
  errorMessage: string;
  changeButtonText: boolean = false;
  showNotifySpinner: boolean = false;

  ngOnInit() {
        this.projectNumber = window.location.pathname?.split('/')[4];

  }
/**
     * Methos to use handle dismiss active model
     */
    dismiss() {
        this.modelService.dismissAll();
    }

    notifyAdmin() {
      this.changeButtonText = false;
      this.showNotifySpinner = true;
      const payload = {
        projectnumber: this.projectNumber
      }
      this.aiSourcingService.notifyAdmin(payload).subscribe((res:any)=>{
        this.showNotifySpinner = false;
        if(res.status == "success") {
          this.changeButtonText = true;
          this.successMessage = 'Notify admin successfully';
          setTimeout(() => {
            this.successMessage = '';
          }, 3000);
        } else {
          this.errorMessage = "Something went wrong";
           setTimeout(() => {
            this.errorMessage = '';
          }, 3000);
        }
      })
    }

}
